import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { InfoDivider } from '../../../AtBat/atbat.style';
import {
    MatchupDetailsContainer,
    MatchupDetailsLabel,
    MainWrapper
} from './MatchupDetails.style';

const MatchupDetails = ({
    matchupMessages,
    isMobile = false,
    isLoading
}) => {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

    useEffect(() => {
        if (matchupMessages.length > 1 && !isLoading) {
            const initialDelay = currentMessageIndex === 0 ? 10000 : 8000;
            const timer = setTimeout(() => {
                setCurrentMessageIndex((prev) => prev + 1);
            }, initialDelay);

            return () => clearTimeout(timer);
        }
    }, [currentMessageIndex, matchupMessages, isLoading]);

    const MatchupLabel = useMemo(() => !isLoading && <MatchupDetailsLabel key={currentMessageIndex} /* key required to re-trigger animation */>
        {matchupMessages[currentMessageIndex % matchupMessages.length]}
    </MatchupDetailsLabel>, [currentMessageIndex, matchupMessages, isLoading]);

    useEffect(() => {
        currentMessageIndex > 0 && setCurrentMessageIndex(0);
    }, [matchupMessages]);

    return (
        <MainWrapper>
            <InfoDivider />
            <MatchupDetailsContainer>
                {MatchupLabel}
            </MatchupDetailsContainer>
            {isMobile && <InfoDivider />}
        </MainWrapper>
    );
};

MatchupDetails.propTypes = {
    matchupMessages: PropTypes.array,
    isMobile: PropTypes.bool,
    isLoading: PropTypes.bool
};

export default MatchupDetails;
